import React, {Component} from 'react';
import {withRouter} from "react-router";
import {translate} from 'react-i18next';

class Advantages extends Component {
  render() {
    const {t} = this.props;
    const adv = ["block1", "block2", "block3", "block4"];
    return (
      <div className={'adve-bar vertical-center'}>
        <div className={'center'}>
          <div className={'max-width advantages-pre-container'}>
            <h2>{t('advantages.title')}</h2>
            <div className={'h-text2-last'}>{t('advantages.text')}</div>
            <div className={'advantages-container'}>
              {adv.map(item => <Block item={item} {...this.props}/>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(translate('home')(Advantages));

class Block extends Component {
  render() {
    const {item, t} = this.props;
    return (
      <div className={'item'} key={item}>
        <div className={'icon ' + item}/>
        <div className={'title'}>{t('advantages.' + item + '.title')}</div>
        <div className={'text'}>{t('advantages.' + item + '.text')}
        </div>
        {/*<div className={'read-more'}>{t('read-more')}</div>*/}
      </div>
    )
  }
}
